import { IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonInput, IonLabel, IonPage, IonRow, IonText, useIonAlert, useIonRouter } from '@ionic/react';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Footer from '../../components/Footer';
import UserTerms from '../../components/UserTerms';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';

interface SignUpProps {
  user: User | null
}

const Signup: React.FC<SignUpProps> = (props) => {

  const siteText = translation();
   
  const lan=siteText.lan.replace("/","")

  const toAccountArray=["home","signin"]

  //
  const [disable, setDisable] = useState(false);

  const [present] = useIonAlert();

  const authSvc = new AuthServ();

  //

  const [userTerms, showUserTerms] = useState<boolean>(false);

  const [eighteenYearsAgo] = useState(() => {
    let today = new Date();
    let upDate = today.setFullYear(today.getFullYear() - 18);
    let eighteenYearsAgo = new Date(upDate);
    return (`${eighteenYearsAgo.getFullYear()}-${('0' + (eighteenYearsAgo.getMonth() + 1)).slice(-2)}-${('0' + eighteenYearsAgo.getDate()).slice(-2)}`);
  })
  /*Form elements */
  const [firstName, setFirstName] = useState<any>();
  const [lastName, setLastName] = useState<any>();
  const [dateOfBirth, setDateOfBirth] = useState<any>();
  const [email, setEmail] = useState<any>();
  const [password, setPassWord] = useState<any>();
  const [checked, setChecked] = useState(false);

  //
  const router = useIonRouter();

  
  //
  const onSubmit = async (e: any) => {
    e.preventDefault();
    if (!checked) {
      presentRequirement();
      return
    }
    setDisable(true);
    let userData = {
      username: `${firstName} ${lastName}`,
      firstname: firstName,
      lastname: lastName,
      dateOfBirth: dateOfBirth,
      lan:lan,
      email: email,
      password: password
    }
    let response = await authSvc.registerUser(userData);
    if (response.success) {
      e.target.reset();
      setDisable(false);
      presentSuccess();
    } else {
      setDisable(false);
    }
    return
  }

  /*Close open user terms  */
  const toggleUserTerms = () => {
    let current = userTerms;
    showUserTerms(!current);
  }

  /*Present success message */
  const presentSuccess = () =>
    present({
      cssClass: 'my-css',
      header: 'Account creation',
      message: siteText.signUpSuccess,
      buttons: [
        `${siteText.loginPrimary}`,
      ],
      onDidDismiss: (e) => {
        if(router.routeInfo.lastPathname && toAccountArray.some((item:string) => router.routeInfo.lastPathname?.includes(item)))  {
          router.push(`/${lan}/signin`, "forward", "push")
        }else{
          router.goBack()
        }
      },
    })

  //
  const presentRequirement = () =>
    present({
      cssClass: 'my-css',
      header: 'User terms',
      message: siteText.signUpRequireAgreement,
      buttons: [
        'Ok',
      ],
      onDidDismiss: (e) => { },
    })
  return (
    <IonPage className='pageContent'>
      <IonContent >
        <IonGrid className='sw_sp_md'>
          {!props.user &&
          <>
          {!userTerms ?
            <IonRow className='ion-justify-content-center ion-align-items-center innerBody'>
              <IonCol sizeSm='8' sizeMd='6'>
                <h1 className='ion-text-center ion-margin-bottom'>{siteText.signupTitle}</h1>
                <form onSubmit={onSubmit}>
                  <IonLabel>{siteText.signupFirstName}</IonLabel>
                  <IonInput className='ion-margin-top ion-margin-bottom' type='text' placeholder={siteText.signupFirstNamePlaceHolder} required onIonChange={e => setFirstName(e.detail.value)}></IonInput>
                  <IonLabel>{siteText.signupLastName}</IonLabel>
                  <IonInput className='ion-margin-top ion-margin-bottom' type='text' placeholder={siteText.signupLastNamePlaceHolder} required onIonChange={e => setLastName(e.detail.value)}></IonInput>
                  <IonLabel>{siteText.signupDateOfBirth}</IonLabel>
                  <IonInput className='ion-margin-top ion-margin-bottom' type='date' max={eighteenYearsAgo} placeholder={siteText.signupDateOfBirth} required onIonChange={e => setDateOfBirth(e.detail.value)}></IonInput>
                  <IonLabel>{siteText.signupEmailLabel}</IonLabel>
                  <IonInput className='ion-margin-top ion-margin-bottom' type='email' placeholder={siteText.signupEmailPlaceHolder} required onIonChange={e => setEmail(e.detail.value)}></IonInput>
                  <IonLabel>{siteText.signupPasswordLabel}</IonLabel>
                  <IonInput className='ion-margin-top ion-margin-bottom' type='password' placeholder={siteText.signupPasswordPlaceHolder} required onIonChange={e => setPassWord(e.detail.value)}></IonInput>
                  <IonLabel > 
                  <IonCheckbox className='ion-margin-end'  checked={checked} onIonChange={e => setChecked(e.detail.checked)} ></IonCheckbox>
                    <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.signupConditionConfirmationstring}</Link>
                  </IonLabel>
                  <br></br>
                  <IonButton strong disabled={disable || !checked} type="submit" className='sw_mt_md'> <IonText color='light'>{siteText.signupPrimary}</IonText></IonButton>
                  <p><Link to={`/${lan}/signin`} >{siteText.signupHasAccount}</Link> - <Link to={`/${lan}/password_reset`}>{siteText.signupLostPassword}</Link></p>
                </form>
              </IonCol>
            </IonRow> :
            <IonRow className='innerBody'>
              <IonCol sizeSm='10' sizeMd='10' offsetSm='1'>
                <UserTerms goBack={toggleUserTerms} />
              </IonCol>
            </IonRow>}
            </>
          }
            {
              props.user &&

              <IonRow>
                <IonCol offsetSm='3' sizeSm='6' offsetMd='4' sizeMd="4" className='ion-text-center'>
                <h1 className='ion-text-center'>{siteText.loginTitle}</h1>
                <p>{siteText.siteLoggedAlready}</p>
                <IonButton routerLink={`/${lan}/account/start`} fill='outline'> {siteText.siteToMyAccount}</IonButton>
                </IonCol>
              </IonRow>
            }
        </IonGrid>
        <Footer></Footer>
      </IonContent>
    </IonPage>
  );
};

export default Signup;
